export default `<g fill="currentColor"> <polygon points="13.8,6.6 12.4,8 15.4,11.1 4.6,11.1 4.6,13.1 15.4,13.1 12.4,16.3 13.8,17.7 19.2,12.1 "/> <g fill="currentColor">`;
